__turbopack_context__.v({
  "linkLevel1": "category-navigation-module__dvslSq__linkLevel1",
  "linkLevel2": "category-navigation-module__dvslSq__linkLevel2",
  "linkLevel3": "category-navigation-module__dvslSq__linkLevel3",
});
